import { render, staticRenderFns } from "./reserveDental.vue?vue&type=template&id=573d1f1f"
import script from "./reserveDental.vue?vue&type=script&lang=js"
export * from "./reserveDental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports